import { render, staticRenderFns } from "./PnOnboardingPanelList.vue?vue&type=template&id=9769d4fc&scoped=true"
import script from "./PnOnboardingPanelList.vue?vue&type=script&lang=js"
export * from "./PnOnboardingPanelList.vue?vue&type=script&lang=js"
import style0 from "./PnOnboardingPanelList.vue?vue&type=style&index=0&id=9769d4fc&prod&lang=scss&scoped=true"
import style1 from "./PnOnboardingPanelList.vue?vue&type=style&index=1&id=9769d4fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9769d4fc",
  null
  
)

export default component.exports